import { MenuPassThrough } from "primeng/menu";

export const menuPtOptions: MenuPassThrough = {
    root: {
        class: "mt-2",
        style: {
            width: "280px",
        },
    },
    item: {
        class: "grid grid-cols-12 gap-4",
    },
    itemContent: {
        class: "py-1 px-2",
        style: {
            borderTop: "1px solid var(--p-azara-grey-450)",
        },
    },
};
